import { SerializedError } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

export const globalErrorToast = (err: { error: { data: SerializedError; status: number } }) => {
  const { error } = err;
  const errorMessage = JSON.stringify(error?.data?.message);

  toast.error(errorMessage);
};
